<template>
    <CCard class="mob-pd-0px">
        <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
            <CRow class="flex-flow-column">
                <CCol>
                    <strong>{{ $t("taxSetup.title") }}</strong>
                </CCol>

                <p class="desc">{{ $t("taxSetup.desc") }}</p>
            </CRow>
            <cStatusButton v-if="GET_SEL_FLIGHT_SCHEDULE"
                    class="generate-ex-btn label-margin-unset"
                    :isConfirm="false"
                    :defaultStatus="taxSetup.isactive"
                    @change="taxSetup.isactive=!taxSetup.isactive"
                    :label="{checked: $t('taxSetup.active'), unchecked: $t('taxSetup.inactive')}"
                  ></cStatusButton>
        </CCardHeader>
        <ValidationObserver v-slot="{ handleSubmit }">
            <CCardBody class="user-manage-table pt-0px pb-0px">

                <br/>
                <CRow class="justify-content-center">
                    <!--          <label>{{$t('taxSetup.taxCode')}}</label>-->
                    <CCol md="7">

                        <cTextInputComponent class="seprat-lab-col-12"
                                :upperCase='true' 
                                v-model="taxSetup.taxCode"
                                :placeholder="$t('taxSetup.taxCodePl')"
                                  :rules="'required|max:5|minimum:2|alpha_num|noInitialSpace'"
                                :label="$t('taxSetup.taxCode')"
                        />
                    </CCol>

                </CRow>
                <br />
                <CRow class="justify-content-center">
                    <CCol md="7">
                        <cTextInputComponent class="seprat-lab-col-12"
                                v-model="taxSetup.desc"
                                :placeholder="$t('taxSetup.descriptionPl')"
                                rules="required"
                                :label="$t('taxSetup.description')"
                        />
                    </CCol>
                </CRow>
                <br/>
                <CRow class="justify-content-center">
                    <CCol md="7" class="d-flex">
                        <label class="min-w-150 min-w-70px">{{$t('taxSetup.taxType')}}</label>

                        <div class="d-flex ">
                            <div class="checkbox d-flex align-item-center mr-15px"  v-for="(taxType,index) in lsTaxType"
                                 :key="index">
                                <input type="checkbox" v-model="taxType.isActive" v-on:input="updateTaxType(taxType)"
                                       class="m-auto mr-10px ml-0px  c-pointer" :id='taxType.name'/>

                                <label :for=taxType.name class="mb-0 c-pointer">{{taxType.name}}</label>
                            </div>
                        </div>
                        <ValidationProvider :rules="'required'" v-slot="{ errors }">
                            <CRow v-model="selTaxType"></CRow>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </CCol>

                </CRow>
                <br />
                <CRow class="justify-content-center">
                    <CCol md="7" class="d-flex">
                        <label class="  min-w-150">{{$t('taxSetup.cabinType')}}</label>
                        <br/>
                        <div class="d-flex">
                            <div class="checkbox d-flex align-item-center mr-15px" v-for="(cabinType,index) in lsCabinType"
                                 :key="index">
                                <input
                                        type="checkbox"
                                        v-model="cabinType.isActive"
                                        v-on:input="updateCabinType(cabinType)"
                                        class="m-auto mr-10px ml-0px  c-pointer"
                                        :id='cabinType.name'
                                />

                                <label class="mb-0  c-pointer" :for=cabinType.name>{{cabinType.name}}</label>
                            </div>
                        </div>
                        <ValidationProvider :rules="'required'" v-slot="{ errors }">
                            <CRow v-model="selCabinType"></CRow>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </CCol>

                </CRow>
                <br />
                <CRow class="justify-content-center">
                    <CCol md="7" class="d-flex">
                        <label class=" min-w-150">{{$t('taxSetup.paxType')}}</label>
                        <br/>
                        <div class="d-flex">
                            <div class="checkbox d-flex align-item-center mr-10px" v-for="(paxType,index) in lsPassengerType"
                                 :key="index">
                                <input type="checkbox" v-model="paxType.isActive" v-on:input="updatePaxType(paxType)"
                                       class="m-auto ml-0px mr-10px  c-pointer" :id='paxType.code'/>

                                <label class="mb-0  c-pointer" :for=paxType.code>{{paxType.name}}</label>
                            </div>
                        </div>
                        <ValidationProvider :rules="'required'" v-slot="{ errors }">
                            <CRow v-model="selPaxType"></CRow>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </CCol>
                </CRow>
                <br/>
                <CRow class="justify-content-center">
                    <CCol md="7" class="d-flex align-item-center">

                        <label class="min-w-150">{{$t('taxSetup.departureCountry')}}</label>
                        <cDropDown
                                class="dpTopalign w-100"
                                key="mobilecode"
                                :isAllowEmpty="false"
                                :defaultCountryCode="defaultCountryCode"
                                :ctrlName="'value'"
                                :ctrlCode="'value'"
                                :isShowCode="false"
                                :isMultiple="false"
                                :isSearchable="true"
                                :url="getCountryServiceURL()"
                                rules="required"
                                :selValue="selDepCountry"
                                v-on:input="onCountryChange"
                        />
                    </CCol>
                </CRow>
                <br />
                <CRow class="justify-content-center">
                    <CCol md="4">
                        <label>{{$t('taxSetup.departureAirports')}}</label>
                        <CRow class="min-h-40px d-flex align-item-center">
                            <CCol md="6" v-for="(depAirport,index) in lsDepAirports" :key="index">
                                <cRadioButton

                                        :key="depAirport.code"
                                        :name="depAirport.code"
                                        :value="depAirport.code"
                                        :label="depAirport.name"
                                        v-on:input="updateDepAirport(index)"
                                        rules="required"
                                        :selValue="lsDepAirports[selDepAirportIndex]"
                                />
                            </CCol>


                            <!-- <div class="checkbox" v-for="(depAirport,index) in lsDepAirports" :key="index">
                              <input
                                type="radio"
                                v-model="depAirport.isActive"
                                v-on:input="updateDepAirport(index)"
                              />



                              <span>{{depAirport.name}}</span>
                            </div>-->

                        </CRow>

                    </CCol>
                    <CCol md="3" >
                        <ValidationProvider :rules="'required'" v-slot="{ errors }" v-if="lsDepAirports[1].isActive">
                            <label for="">Custom</label>
                            <multiselect
                                    v-model="selAirport"
                                    :multiple="true"
                                    label="airportcode"
                                    :allow-empty="true"
                                    :options="lsAirports"
                                    :track-by="'airportcode'"
                                    deselectLabel
                                    deselectGroupLabel
                                    selectLabel
                                    selectedLabel
                                    :placeholder="$t('taxSetup.airportPl')"

                            >
                                <template #noResult>
                                    <strong>{{$t('taxSetup.listEmpty')}}</strong>
                                </template>
                            </multiselect>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </CCol>
                </CRow>
                <br/>
                <div class="justify-content-center">
                    <CRow class="justify-content-center">
                        <CCol md="7">
                            <CRow class="justify-content-center">
                                <CCol md="4">
                                    <cTextInputComponent
                                            rules="required|onlynumber|max_val:100|validDecimal"
                                            v-model="taxSetup.taxPercentage"
                                            :maxLength="5"
                                            :label="$t('taxSetup.taxAmount')"
                                            :placeholder="$t('taxSetup.taxAmountPl')"
                                          
                                    />
                                      <!-- :readonly="GET_SEL_FLIGHT_SCHEDULE ? true : false" -->
                                </CCol>

                                <CCol md="4">
                                    <label>{{'% '+$t('taxSetup.of')+' '+$t('taxSetup.sum')+' '+ $t('taxSetup.of')}}</label>
                                    <ValidationProvider :rules="'required'" v-slot="{ errors }">
                                        <multiselect
                                                v-model="selTaxSetup"
                                                :multiple="true"
                                                label="taxpercentage_on"
                                                :allow-empty="true"
                                                :options="lsTaxSetup"
                                                :track-by="'taxcode'"
                                                deselectLabel
                                                deselectGroupLabel
                                                selectLabel
                                                class="inner-label-none"
                                                selectedLabel
                                                :custom-label="customLabel"
                                                :placeholder="$t('taxSetup.taxSetupPl')"
                                        >
                                            <template #noResult>
                                                <strong>{{$t('taxSetup.listEmpty')}}</strong>
                                            </template>
                                        </multiselect>
                                        <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                            <span>{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </CCol>

                                <CCol md="4">

                                    <cOrgCurrencyDp
                                            v-if="isOrgCurrencyDp && GET_ORG_CURRENCY_RES"
                                            v-model="selCurrency"
                                            :defaultCurrency="defaultCurrency"
                                            :ctrlCode="'id'"
                                            :isShowCode="true"
                                            :isMultiple="false"
                                            :isSearchable="false"
                                            :isAllowEmpty="false"
                                            rules="required"
                                            :label="$t('fareUpload.currency')"
                                            @input="getSelectedCurrency"
                                            class=" m-0 "
                                    ></cOrgCurrencyDp>


                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>


                </div>
                <br />
                <CRow class="justify-content-center">
                    <CCol md="7">
                        <cTextInputComponent
                                rules="onlynumber"
                                v-model="taxSetup.taxFee"
                                :isAmountField="true"
                                :label="$t('taxSetup.fixedFees')"
                                :placeholder="$t('taxSetup.fixedFeesPl')"
                                @onBlur="formatTaxFee(taxSetup.taxFee)"
                                @onFocus="onRemoveCurrFormat(taxSetup.taxFee)"
                        />
                    </CCol>

                </CRow>
                <br />
                <CRow class="justify-content-center">
                    <CCol md="7">
                        <label>{{$t('taxSetup.ticketingDate')}}</label>

                        <HotelDatePicker
                                :hoveringTooltip="false"
                                :closeDatepickerOnClickOutside="true"
                                :showYear="true"
                                :startingDateValue="taxSetup.ticketingDate.from"
                                :endingDateValue="taxSetup.ticketingDate.to"
                                class="h-40px center datepick-o-date"
                                style="transform: translateY(-2px);"
                                :format='DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT'
                                @check-in-changed="onChangeFromDate"
                                @check-out-changed="onChangeToDate"
                                :i18n="assigni18nObjByLang()"
                                :displayClearButton="false"
                                :minNights="0"

                        ></HotelDatePicker>
                    </CCol>
                </CRow>
                <CRow>
                    <CAlert v-if="alertValue" show color="danger">
                        <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                            <p v-for="(value,index) in alertValue.valueList" :key="index">{{value}}</p>
                        </div>
                        <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                            <span>{{$t("cAlert.errorCode")+' : '}}</span>
                            <span v-for="(code,index) in alertValue.codeList" :key="index">{{code +' '}}</span>
                        </div>
                        <div v-if="alertValue&&alertValue.constructor==String">
                            <p>{{alertValue}}</p>
                        </div>
                    </CAlert>
                </CRow>
                <CCardFooter>
                    <CRow>
                        <CButton
                                @click="navToTaxAll"
                                color="danger"
                                class="action-c-btn ml-auto mr-15px"
                        >{{$t('taxSetup.cancelBtn')}}
                        </CButton>
                        <CButton
                                col="12"
                                color="success removewrap"
                                class="action-c-btn"
                                @click.prevent="handleSubmit(onShowCreateTaxModal)"
                        >{{GET_SEL_FLIGHT_SCHEDULE?$t('taxSetup.updateBtn'):$t('taxSetup.createBtn')}}
                        </CButton>
                    </CRow>
                </CCardFooter>
            </CCardBody>
        </ValidationObserver>
        <cAlertModal
                v-if="isCreateTaxModal"
                :buttonList="[{
              name:$t('taxSetup.noBtn'),func:onHideConfirmationModals,color:'danger'},
                {name:$t('taxSetup.yesBtn'),func:onCreateTaxSetup,color:'success'},]"
                :status="2"
                :show="isCreateTaxModal"
                :desc="GET_SEL_FLIGHT_SCHEDULE?$t('taxSetup.updateTaxConfirmation'):$t('taxSetup.createTaxConfirmation')"
        ></cAlertModal>

        <cAlertModal
                v-if="isTaxCreated"
                :buttonList="[{name:$t('taxSetup.okBtn'),func:onHideConfirmationModals,color:'success'}]"
                :status="1"
                :show="isTaxCreated"
                :desc="GET_SEL_FLIGHT_SCHEDULE?$t('taxSetup.taxUpdatedSuccDesc'):$t('taxSetup.taxCreatedSuccDesc')"
        ></cAlertModal>

        <cAlertModal
                v-if="isFailedModal"
                :buttonList="[{name:$t('taxSetup.okBtn'),func:onHideConfirmationModals,color:'danger'}]"
                :status="0"
                :show="isFailedModal"
                :desc="alertValue"
        ></cAlertModal>
    </CCard>
</template>

<script>
import router, { navigate, updateDataEdited } from "../../../router/index";

    import {mapGetters, mapActions} from "vuex";
    import {
        PATHNAME,
        COMPONENT_NAME,
        ORDER,
        TRIP,
        PAX,
      
        DEP_AIRPORTS,
        TAX_AIRPORTS,
        TAX_CABIN_TYPE,DATE_TIME_FORMAT,
        TAX_TYPE
    } from "../../../util/constants";
    import Logger from "../../../services/logger";
    import SERVICE_URL, {
        FILE_NAME,
        LOG_TYPE,
        HTTP_CODES
    } from "../../../config/API_DATA";

    import {
        VALIDATE_SUCCESS_RES,
        getErrorMessage
    } from "../../../util/apiValidate";
    import {
        handleJWT,
        getErrorAlertValue,
        addClassToBody,
        removeClassBody,
        OrderByList,
        cloneData,
        removeCurrFormat
    } from "../../../util/util";
    import BaseConfiguration from "../../../config/base.js";
    import apiGetAirports from "../../../services/apiGetAirports";
    import Multiselect from "vue-multiselect";
    import cTextInputComponent from "../../../components/form/cTextInputComponent";
    // import nb from "../../../translations/validation/nb.json";
    // import en from "../../../translations/validation/en.json";
    import {ValidationObserver, ValidationProvider, localize} from "vee-validate";
    // import VueTimepicker from "vue2-timepicker";
    import cAlertModal from "../../../components/form/cAlertModal";

    import cOrgCurrencyDp from "../../../components/currency/cOrgCurrencyDp";
    import cDropDown from "../../../components/form/cDropDown";
    import apiGetAirportsByCountryCode from "../../../services/apiGetAirportsByCountryCode";
    import apiGetTaxSetupByCountry from "../../../services/apiGetTaxSetupByCountry";

    import apiCreateTaxSetup from "../../../services/apiCreateTaxSetup";
    import apiUpdateTaxSetup from "../../../services/apiUpdateTaxSetup";
    import cRadioButton from "../../../components/form/cRadioButton";
    import {i18n} from "../../../plugins/i18n.js";
import cStatusButton from "../../../components/form/cStatusButton";

import HotelDatePicker from "vue-range-datechooser";

// localize({
//   en: {
//     messages: en.messages
//   },
//   nb: {
//     messages: nb.messages
//   }
// });
export default {
  name: COMPONENT_NAME.TAX_SETUP,
  components: {
    Multiselect,
    cTextInputComponent,
    ValidationObserver,
    ValidationProvider,
    cDropDown,
    cAlertModal,
    cOrgCurrencyDp,
    HotelDatePicker,
    cRadioButton,
    cStatusButton
  },

    //      watch: {    
    //   '$refs.cabin.errors':{
    //     immediate: false, 
    //     deep: true,
    // handler: function (newVal, oldVal) {
    //   console.error(this.$refs.cabin.errors)
  
    //   }
    //   },
      
      
    //   },
        

  data: () => {
    return {
      alertValue: null,
      lsAirlines: [],
      lsAirportCodes: [],

      lsPassengerType: [
        {
          name: i18n.tc("taxSetup.adult"),
          code: PAX.ADULT
        },
        {
          name: i18n.tc("taxSetup.child"),
          code: PAX.CHILDREN
        },
        {
          name: i18n.tc("taxSetup.infant"),
          code: PAX.INFANT
        }
      ],
      lsCabinType: [
        
      ],
      lsTaxType: [
        {
          name: i18n.tc("taxSetup.domesticFlights"),
          code: TAX_TYPE.DOMESTIC,
          isActive: false
        },
        {
          name: i18n.tc("taxSetup.InternationalFlights"),
          code: TAX_TYPE.INTERNATIONAL,
          isActive: false
        }
      ],
      lsDepAirports: [
        {
          name: i18n.tc("taxSetup.allAirports"),
          code: DEP_AIRPORTS.ALL_AIRPORTS,
          isActive: true
        },
        {
          name: i18n.tc("taxSetup.custom"),
          code: DEP_AIRPORTS.CUSTOM,
          isActive: false
        }
      ],
      selDepCountry: null,
      lsAirports: [],
      selAirport: null,
      isOrgCurrencyDp: true,
      defaultCurrency: null,
      selCurrency: null,
      defaultCountryCode: null,
      taxSetup: {
        isactive: null,
        taxCode: null,
        desc: null,
        taxPercentage: null,
        taxPercentageOn:null,
        taxFee: 0,
        ticketingDate: {
          from: new Date(),
          to: new Date()
        }
      },
      isNeedToAssSelAirport: false,
      isCreateTaxModal: false,
      isFailedModal: false,
      isTaxCreated: false,
      selDepAirportIndex: 0,
      selTaxType: [],
      selPaxType: [],
      selCabinType: [],
      lsTaxSetup:[],
      selTaxSetup:null
    };
  },

  methods: {



    getCabinTypes() {
    let retValue
      try {
        if(BaseConfiguration.isDebug) console.log("getCabinTypes");
        if(this.CABIN_TYPE)
         retValue= [{
          name: i18n.tc('taxSetup.economy'),
          code: this.CABIN_TYPE.Economy,
            isActive: false
        },
        {
          name: i18n.tc('taxSetup.business'),
          code: this.CABIN_TYPE.Business,
            isActive: false
        },];
        else
        {
          retValue=[]
        }
  
      } catch (err) {
              let body = Logger.buildRequest(
                FILE_NAME.FARE_UPLOAD_NEW,
                "error in getCabinTypes",
                err.toString(),
                "getCabinTypes",
                LOG_TYPE.ERROR
              );
              Logger.getResponse(body);
            }
        return retValue;
      },
    onChangeFromDate(pDate) {
        try {
          if(BaseConfiguration.isDebug) console.log("onChangeFromDate");
        this.taxSetup.ticketingDate.from=pDate;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.TAX_SETUP,
                  "error in onChangeFromDate",
                  err.toString(),
                  "onChangeFromDate",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
       
        }, 
         onChangeToDate(pDate) {
        try {
          if(BaseConfiguration.isDebug) console.log("onChangeToDate");
        this.taxSetup.ticketingDate.to=pDate;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.TAX_SETUP,
                  "error in onChangeToDate",
                  err.toString(),
                  "onChangeToDate",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
       
        }, 
     customLabel(option) {
      return `${option.taxcode} `;
    },
    navToTaxAll() {
      try {
        if (BaseConfiguration.isDebug) console.log("navToTaxAll");
        navigate(PATHNAME.TAX_ALL);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in navToTaxAll",
          err.toString(),
          "navToTaxAll",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
     formatTaxFee(pTaxFee) {

     if (BaseConfiguration.isDebug) console.log(" formatTaxFee");
      try {

          if(this.selCurrency&&this.selCurrency.currency_code)
        {
           this.taxSetup.taxFee= this.$options.filters.currencyFormat(pTaxFee,this.selCurrency.currency_code.code);
        }


        // }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in formatTaxFee",
          err.toString(),
          "formatTaxFee",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
     onRemoveCurrFormat(pTaxFee) {
        try {
          if(BaseConfiguration.isDebug) console.log("onRemoveCurrFormat");

               this.taxSetup.taxFee= removeCurrFormat(pTaxFee);

        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.TAX_SETUP,
                  "error in onRemoveCurrFormat",
                  err.toString(),
                  "onRemoveCurrFormat",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }

        },
    onShowCreateTaxModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("onShowCreateTaxModal");
        this.isCreateTaxModal = true;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in onShowCreateTaxModal",
          err.toString(),
          "onShowCreateTaxModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    updateCabinType(pCabinType) {
      try {
        if (BaseConfiguration.isDebug) console.log("updateCabinType");
        let selCabin = cloneData(this.selCabinType);
        if (!pCabinType.isActive) {
          selCabin.push(pCabinType);
        } else {
          for (let i = 0; i < selCabin.length; i++) {
            if (pCabinType.code == selCabin[i].code) {
              this.$delete(selCabin, i);
            }
          }
        }
        this.selCabinType = selCabin;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in updateCabinType",
          err.toString(),
          "updateCabinType",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    updatePaxType(pPaxType) {
      try {
        if (BaseConfiguration.isDebug) console.log("updatePaxType");
        let selPax = cloneData(this.selPaxType);
        if (!pPaxType.isActive) {
          selPax.push(pPaxType);
        } else {
          for (let i = 0; i < selPax.length; i++) {
            if (pPaxType.code == selPax[i].code) {
              this.$delete(selPax, i);
            }
          }
        }
        this.selPaxType = selPax;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in updatePaxType",
          err.toString(),
          "updatePaxType",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    updateTaxType(pTaxType) {
      try {
        if (BaseConfiguration.isDebug) console.log("updateTaxType");
        let selTax = cloneData(this.selTaxType);
        if (!pTaxType.isActive) {
          selTax.push(pTaxType);
        } else {
          for (let i = 0; i < selTax.length; i++) {
            if (pTaxType.code == selTax[i].code) {
              this.$delete(selTax, i);
            }
          }
        }
        this.selTaxType = selTax;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in updateTaxType",
          err.toString(),
          "updateTaxType",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onHideConfirmationModals() {
      try {
        if (BaseConfiguration.isDebug) console.log("onHideConfirmationModals");

        this.isCreateTaxModal = false;
        this.isFailedModal = false;

        if (this.isTaxCreated) {
          navigate(PATHNAME.TAX_ALL);
          this.isTaxCreated = false;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in onHideConfirmationModals",
          err.toString(),
          "onHideConfirmationModals",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    updateDepAirport(pIndex) {
      try {
        if (BaseConfiguration.isDebug) console.log("updateDepAirport");
        this.selDepAirportIndex = pIndex;
        for (let i = 0; i < this.lsDepAirports.length; i++) {
          if (i != pIndex) {
            this.lsDepAirports[i].isActive = false;
          }
        }

        this.lsDepAirports[pIndex].isActive = true;
        // console.error(this.lsDepAirports[pIndex].isActive)
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in updateDepAirport",
          err.toString(),
          "updateDepAirport",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    assigni18nObjByLang() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assigni18nObjByLang");

        retValue = {
          night: this.$t("flightDatePicker.night"),
          nights: this.$t("flightDatePicker.nights"),
          "day-names": [
            this.$t("flightDatePicker.sun"),
            this.$t("flightDatePicker.mon"),
            this.$t("flightDatePicker.tue"),
            this.$t("flightDatePicker.wed"),
            this.$t("flightDatePicker.thur"),
            this.$t("flightDatePicker.fri"),
            this.$t("flightDatePicker.sat")
          ],
          "check-in": "",
          "check-out": "",
          "month-names": [
            this.$t("flightDatePicker.jan"),
            this.$t("flightDatePicker.feb"),
            this.$t("flightDatePicker.mar"),
            this.$t("flightDatePicker.apr"),
            this.$t("flightDatePicker.may"),
            this.$t("flightDatePicker.jun"),
            this.$t("flightDatePicker.july"),
            this.$t("flightDatePicker.aug"),
            this.$t("flightDatePicker.sep"),
            this.$t("flightDatePicker.oct"),
            this.$t("flightDatePicker.nov"),
            this.$t("flightDatePicker.dec")
          ]
        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in assigni18nObjByLang",
          err.toString(),
          "assigni18nObjByLang",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getSelectedCurrency(pCurrency) {
      try {
        if (BaseConfiguration.isDebug) console.log("getSelectedCurrency");
        if (pCurrency) {
          this.selCurrency = pCurrency;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in getSelectedCurrency",
          err.toString(),
          "getSelectedCurrency",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async onCountryChange(pSelCountry) {
      try {
        if (BaseConfiguration.isDebug) console.log("onCountryChange");
        this.selDepCountry = pSelCountry;
          this.lsTaxSetup= await this.getTaxSetupByCountryCode(pSelCountry.countrycode);
        this.lsAirports = await this.getAirportsByCountryCode(
          pSelCountry.countrycode
        );
        this.selAirport=null
        if (this.isNeedToAssSelAirport && this.GET_SEL_FLIGHT_SCHEDULE) {
          this.isNeedToAssSelAirport = false;
         
          this.selAirport = this.assignSelAirports(
            this.lsAirports,
            this.GET_SEL_FLIGHT_SCHEDULE.departureairports
          );
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in onCountryChange",
          err.toString(),
          "onCountryChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    assignSelAirports(pLsAirport, pDepAirport) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("assignSelAirports");
        for (let i = 0; i < pDepAirport.length; i++) {
          for (let j = 0; j < pLsAirport.length; j++) {
            if (pDepAirport[i] == pLsAirport[j].airportcode) {
              retValue.push(pLsAirport[j]);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in assignSelAirports",
          err.toString(),
          "assignSelAirports",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getCountryServiceURL() {
      if (BaseConfiguration.isDebug) console.log("getCountryServiceURL");
      return SERVICE_URL.GET_COUNTRY_LIST;
    },
    async getAirportsByCountryCode(pCountryCode) {
      let airportList = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getAirportsByCountryCode");
        let airportRequest = apiGetAirportsByCountryCode.buildRequest(
          pCountryCode
        );

        if (airportRequest) {
          let airportResponse = await apiGetAirportsByCountryCode.getResponse(
            airportRequest
          );

          if (VALIDATE_SUCCESS_RES(airportResponse)) {
            this.alertValue = null;
            airportList = airportResponse.data.data.CountryAirports;
          } else {
            let error = getErrorMessage(airportResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in getAirportsByCountryCode",
          err.toString(),
          "getAirportsByCountryCode",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return airportList;
    },
     async getTaxSetupByCountryCode(pCountryCode) {
      let airportList = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getTaxSetupByCountryCode");
        let airportRequest = apiGetTaxSetupByCountry.buildRequest(
          pCountryCode
        );

        if (airportRequest) {
          let airportResponse = await apiGetTaxSetupByCountry.getResponse(
            airportRequest
          );

          if (VALIDATE_SUCCESS_RES(airportResponse)) {
            this.alertValue = null;
            airportList = airportResponse.data.data.TaxSetupList;
          } else {
            let error = getErrorMessage(airportResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in getTaxSetupByCountryCode",
          err.toString(),
          "getTaxSetupByCountryCode",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return airportList;
    },
    getCurrencyObj(pOrgCurrencies, pCurrency) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getCurrencyObj");
        if (
          pOrgCurrencies &&
          pOrgCurrencies.data &&
          pOrgCurrencies.data.data &&
          pCurrency
        ) {
          for (let i = 0; i < pOrgCurrencies.data.data.length; i++) {
            if (pOrgCurrencies.data.data[i].currency_code == pCurrency) {
              retValue = pOrgCurrencies.data.data[i];
              break;
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in getCurrencyObj",
          err.toString(),
          "getCurrencyObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    assignCabinType(pLsCabinType, pCabinType) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assignCabinType");
        for (let i = 0; i < pCabinType.length; i++) {
          for (let j = 0; j < pLsCabinType.length; j++) {
            if (pCabinType[i] == pLsCabinType[j].code) {
              pLsCabinType[j].isActive = true;
              this.selCabinType.push(pLsCabinType[j]);
            }
          }
        }
        retValue = pLsCabinType;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in assignCabinType",
          err.toString(),
          "assignCabinType",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    assignDepAirports(pLsDepAirports, pDepAirport) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assignDepAirports");
        if (pDepAirport[0] == this.$t('taxAll.allAirport')) {
          pLsDepAirports[0].isActive = true;
          pLsDepAirports[1].isActive = false;
          this.selDepAirportIndex = 0;
        } else {
          this.selDepAirportIndex = 1;
          pLsDepAirports[0].isActive = false;
          pLsDepAirports[1].isActive = true;
          this.isNeedToAssSelAirport = true;
        }
        retValue = pLsDepAirports;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in assignDepAirports",
          err.toString(),
          "assignDepAirports",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    assignTaxType(pLsTaxType, pTaxType) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assignTaxType");
        for (let i = 0; i < pTaxType.length; i++) {
          for (let j = 0; j < pLsTaxType.length; j++) {
            if (pTaxType[i] == pLsTaxType[j].code) {
              pLsTaxType[j].isActive = true;
              this.selTaxType.push(pLsTaxType[j]);
            }
          }
        }
        retValue = pLsTaxType;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in assignTaxType",
          err.toString(),
          "assignTaxType",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    assignTaxSetupCodes(pLsTaxSetup) {
      let retValue=[];
      try {
        if (BaseConfiguration.isDebug) console.log("assignTaxSetupCodes");

          for (let i = 0; i < pLsTaxSetup.length; i++) {
              let taxcodeObj={
                taxcode:pLsTaxSetup[i]
              }
              retValue.push(taxcodeObj);


        }

      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in assignTaxSetupCodes",
          err.toString(),
          "assignTaxSetupCodes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    assignPaxType(pLsPassengerType, pPaxType) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assignPaxType");
        for (let i = 0; i < pPaxType.length; i++) {
          for (let j = 0; j < pLsPassengerType.length; j++) {
            if (pPaxType[i] == pLsPassengerType[j].code) {
              pLsPassengerType[j].isActive = true;
              this.selPaxType.push(pLsPassengerType[j]);
            }
          }
        }
        retValue = pLsPassengerType;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in assignPaxType",
          err.toString(),
          "assignPaxType",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    assignTaxSetup(pTaxSetup) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assignTaxSetup");

        if (pTaxSetup) {
          let lsCabinType = this.assignCabinType(
            this.lsCabinType,
            pTaxSetup.cabintype
          );
          if (lsCabinType) {
            this.lsCabinType = lsCabinType;
          }
          let lsDepAirports = this.assignDepAirports(
            this.lsDepAirports,
            pTaxSetup.departureairports
          );
          if (lsDepAirports) {
            this.lsDepAirports = lsDepAirports;
          }
          this.defaultCountryCode = pTaxSetup.departurecountry;
          this.taxSetup.isactive = pTaxSetup.isactive;
          this.taxSetup.taxCode = pTaxSetup.taxcode;
          this.taxSetup.desc = pTaxSetup.taxdesc;
          this.taxSetup.taxPercentage = pTaxSetup.taxpercentage+'';
          this.taxSetup.taxFee = pTaxSetup.tax_fixed_fee;
          this.taxSetup.ticketingDate.from = new Date(
            pTaxSetup.ticketingdate_from
          );
          this.taxSetup.ticketingDate.to = new Date(pTaxSetup.ticketingdate_to);

          let lsTaxType = this.assignTaxType(this.lsTaxType, pTaxSetup.taxtype);
          if (lsTaxType) {
            this.lsTaxType = lsTaxType;
          }
          let lsPassengerType = this.assignPaxType(
            this.lsPassengerType,
            pTaxSetup.paxtype
          );
          if (lsPassengerType) {
            this.lsPassengerType = lsPassengerType;
          }
           let lsTaxPercentageOn = this.assignTaxSetupCodes(
            pTaxSetup.taxpercentage_on
          );
          if (lsTaxPercentageOn) {
            this.selTaxSetup = lsTaxPercentageOn;
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in assignTaxSetup",
          err.toString(),
          "assignTaxSetup",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    createTaxSetupRequest(pTaxSetup) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("createTaxSetupRequest");

        retValue = {
          taxCode: pTaxSetup.taxCode.toUpperCase(),
          taxDesc: pTaxSetup.desc,
          taxType: this.getTaxType(this.lsTaxType),
          cabinType: this.getCabinType(this.lsCabinType),
          paxType: this.getPaxType(this.lsPassengerType),
          departureCountry: this.selDepCountry
            ? this.selDepCountry.countrycode
            : null,
          departureAirports: this.getDepAirport(this.lsDepAirports),
          taxPercentage: Number(pTaxSetup.taxPercentage),
          taxPercentage_on:this.getTaxSetup(this.selTaxSetup),///["BaseFare","AX"]
          tax_fixed_fee: pTaxSetup.taxFee,
          tax_fixed_currency: this.selCurrency
            ? this.selCurrency.currency_code.code
            : null,
          ticketingdate_from: this.$options.filters.formatDate(
            pTaxSetup.ticketingDate.from,
            DATE_TIME_FORMAT.API_DATE_FORMAT
          ),
          ticketingdate_to: this.$options.filters.formatDate(
            pTaxSetup.ticketingDate.to,
            DATE_TIME_FORMAT.API_DATE_FORMAT
          )
        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in createTaxSetupRequest",
          err.toString(),
          "createTaxSetupRequest",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    async onCreateTaxSetup() {
      try {
        if (BaseConfiguration.isDebug) console.log("onCreateTaxSetup");
      updateDataEdited(false);

        // if (getAllAirlineReq) {
        if (this.GET_SEL_FLIGHT_SCHEDULE) {
          let taxSetupReq = this.updateTaxSetupRequest(this.taxSetup);
          if (taxSetupReq) {
            this.isCreateTaxModal = false;
            let retFlightScheRes = await this.updateTaxSetup(taxSetupReq);
            if (retFlightScheRes) {
              this.isTaxCreated = true;
            } else {
              this.isFailedModal = true;
            }
          } else {
            throw "invalid request";
          }
        } else {
          let taxSetupReq = this.createTaxSetupRequest(this.taxSetup);
          if (taxSetupReq) {
            this.isCreateTaxModal = false;
            let retFlightScheRes = await this.createTaxSetup(taxSetupReq);
            if (retFlightScheRes) {
              this.isTaxCreated = true;
            } else {
              this.isFailedModal = true;
            }
          } else {
            throw "invalid request";
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in onCreateTaxSetup",
          err.toString(),
          "onCreateTaxSetup",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getPaxType(pLsPaxType) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getPaxType");
        for (let i = 0; i < pLsPaxType.length; i++) {
          if (pLsPaxType[i].isActive) {
            retValue.push(pLsPaxType[i].code);
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in getPaxType",
          err.toString(),
          "getPaxType",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getTaxSetup(pLsTaxSetup) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getTaxSetup");
        if(pLsTaxSetup){

        for (let i = 0; i < pLsTaxSetup.length; i++) {

            retValue.push(pLsTaxSetup[i].taxcode);

        }
         }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in getTaxSetup",
          err.toString(),
          "getTaxSetup",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getTaxType(pLsTaxType) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getTaxType");
        for (let i = 0; i < pLsTaxType.length; i++) {
          if (pLsTaxType[i].isActive) {
            retValue.push(pLsTaxType[i].code);
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in getTaxType",
          err.toString(),
          "getTaxType",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getCabinType(pLsCabinType) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getCabinType");
        for (let i = 0; i < pLsCabinType.length; i++) {
          if (pLsCabinType[i].isActive) {
            retValue.push(pLsCabinType[i].code);
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in getCabinType",
          err.toString(),
          "getCabinType",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getDepAirport(pLsDepAirport) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getDepAirport");
        if (pLsDepAirport[0].isActive) {
          retValue.push(pLsDepAirport[0].code);
        } else if (pLsDepAirport[1].isActive) {
          for (let i = 0; i < this.selAirport.length; i++) {
            retValue.push(this.selAirport[i].airportcode);
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in getDepAirport",
          err.toString(),
          "getDepAirport",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    updateTaxSetupRequest(pTaxSetup) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updateTaxSetupRequest");

        retValue = {
          id: this.GET_SEL_FLIGHT_SCHEDULE
            ? Number(this.GET_SEL_FLIGHT_SCHEDULE.id)
            : null,
          taxCode: pTaxSetup.taxCode.toUpperCase(),
          taxDesc: pTaxSetup.desc,
          taxType: this.getTaxType(this.lsTaxType),
          cabinType: this.getCabinType(this.lsCabinType),
          paxType: this.getPaxType(this.lsPassengerType),
          departureCountry: this.selDepCountry
            ? this.selDepCountry.countrycode
            : null,
          departureAirports: this.getDepAirport(this.lsDepAirports),
          taxPercentage: pTaxSetup.taxPercentage,
          taxPercentage_on: this.getTaxSetup(this.selTaxSetup),
          tax_fixed_fee: pTaxSetup.taxFee,
          tax_fixed_currency: this.selCurrency
            ? this.selCurrency.currency_code.code
            : null,
          ticketingdate_from: this.$options.filters.formatDate(
            pTaxSetup.ticketingDate.from,
            DATE_TIME_FORMAT.API_DATE_FORMAT
          ),
          ticketingdate_to: this.$options.filters.formatDate(
            pTaxSetup.ticketingDate.to,
            DATE_TIME_FORMAT.API_DATE_FORMAT
          ),
          isactive: pTaxSetup.isactive
        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in updateTaxSetupRequest",
          err.toString(),
          "updateTaxSetupRequest",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async updateTaxSetup(pTaxSetupReq) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updateTaxSetup");
        let scheduleRequest = apiUpdateTaxSetup.buildRequest(pTaxSetupReq);

        if (scheduleRequest) {
          let scheduleResponse = await apiUpdateTaxSetup.getResponse(
            scheduleRequest
          );

          if (VALIDATE_SUCCESS_RES(scheduleResponse)) {
            this.alertValue = null;
            retValue = scheduleResponse.data.data;
          } else {
            let error = getErrorMessage(scheduleResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue =  getErrorAlertValue(error,true,true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in updateTaxSetup",
          err.toString(),
          "updateTaxSetup",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    async createTaxSetup(pTaxSetupReq) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("createTaxSetup");

        let scheduleRequest = apiCreateTaxSetup.buildRequest(pTaxSetupReq);

        if (scheduleRequest) {
          let scheduleResponse = await apiCreateTaxSetup.getResponse(
            scheduleRequest
          );

          if (VALIDATE_SUCCESS_RES(scheduleResponse)) {
            this.alertValue = null;
            retValue = scheduleResponse.data.data;
          } else {
            let error = getErrorMessage(scheduleResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error,true,true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in createTaxSetup",
          err.toString(),
          "createTaxSetup",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    }
  },

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");

      this.lsCabinType= this.getCabinTypes() 
      if (this.GET_SEL_FLIGHT_SCHEDULE) {
        this.assignTaxSetup(this.GET_SEL_FLIGHT_SCHEDULE);

        this.defaultCurrency = this.GET_SEL_FLIGHT_SCHEDULE.tax_fixed_currency;

        this.isOrgCurrencyDp = false;
        let that = this;
        setTimeout(function() {
          that.isOrgCurrencyDp = true;
        });
      }
      updateDataEdited(true);
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.TAX_SETUP,
        "error in  Created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  computed: {
    DATE_TIME_FORMAT()
          {
            return DATE_TIME_FORMAT
          },
  
    ...mapGetters("sFlightSchedule", {
      GET_SEL_FLIGHT_SCHEDULE: "GET_SEL_FLIGHT_SCHEDULE"
    }),
    ...mapGetters("sContract", {
      GET_SELECTED_CONTRACT: "GET_SELECTED_CONTRACT",
      CABIN_TYPE:'GET_CABIN_TYPE'
    }),
    
    ...mapGetters("sCurrencyLs", {
      GET_ORG_CURRENCY_RES: "GET_ORG_CURRENCY_RES"
    })
  },
  beforeCreate() {
    addClassToBody(COMPONENT_NAME.TAX_SETUP);
  },

  beforeDestroy() {
    removeClassBody();
  }
};
</script>
